<template>
  <az-formbar>
    <div class="show header-pregao">
      <div class="itens">
        <div class="item pl-2">
          <label>Número Processo</label>
          <span>{{licitacao.numProcesso || '-'}}</span>
          <br>
          <span v-if="licitacao.numRepeticao > 0">
            <strong>Repetição:</strong> {{licitacao.numRepeticao || '-'}}
          </span>
        </div>
        <div class="item">
          <label>Situação</label>
          <span>{{ obterSituacaoCredenciamento }}</span>
        </div>
        <div class="item">
          <label>Edital</label>
          <span>{{licitacao.numeroEdital || '-'}}</span>
        </div>
        <div class="item">
          <label>Abertura</label>
          <span>{{licitacao.dataAbertura | az-date('DD/MM/YYYY HH:mm')}}</span>
        </div>
      </div>
      <div class="actions">
        <div class="acesso-dropdown" ref="acessoDropdown">
            <az-call-to-action dark :active="true" :outline="true"
                               @click="toggleAcessoMenu" class="no-mobile">
                ACESSAR
            </az-call-to-action>
            <div v-if="showAcessoMenu" class="acesso-menu">
              <button type="button" class="acesso-menu-item" @click="acessarComo('comprador')">Comprador</button>
              <button type="button" class="acesso-menu-item" @click="acessarComo('fornecedor')">Fornecedor</button>
            </div>
        </div>
      </div>
    </div>
  </az-formbar>
</template>

<script>
import {mapState} from 'vuex'
import moment from 'moment/moment'

export default {
    name: 'CredenciamentoVisualizacaoAcoes',
    props: {
        lotes: {
            type: Array,
            default: () => []
        },
        exibirBotaoHistorico: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showAcessoMenu: false
        }
    },
    computed: {
        ...mapState(['licitacao']),
        obterSituacaoCredenciamento() {
            if (this.licitacao.publicado) {
                if (this.ehCredenciamentoAguardandoAbertura) {
                    return 'Ag. Abertura'
                } else {
                    return 'Aberto'
                }
            } else {
                return 'Em Elaboração'
            }
        },
        ehCredenciamentoAguardandoAbertura() {
            if (this.licitacao.publicado) {
                const dataAbertura = moment(this.licitacao.dataAbertura)
                const dataAtual = moment(new Date())
  
                return dataAtual.isBefore(dataAbertura)
            }
            return false
        },
    },
    methods:{
        toggleAcessoMenu(){
            this.showAcessoMenu = !this.showAcessoMenu
        },
        acessarComo(tipo){
            const licitacaoId = this.licitacao.id
            const host = window.location.host
            const base = `${window.location.protocol}//${host}`

            if (tipo === 'comprador') {
                const pathComprador = `/licitacao/#/credenciamento/${licitacaoId}/dadosGerais`
                window.open(`${base}${pathComprador}`, '_blank')
            } else if (tipo === 'fornecedor') {
                const pathFornecedor = `/licitacao/#/credenciamento/${licitacaoId}/proposta/dadosGerais`
                window.open(`${base}${pathFornecedor}`, '_blank')
            }
            this.showAcessoMenu = false
        },
        acessarCredenciamento(){
            this.toggleAcessoMenu()
        },
    },
    mounted(){
        this._onClickOutside = (e) => {
            const root = this.$refs.acessoDropdown
            if (this.showAcessoMenu && root && !root.contains(e.target)) {
                this.showAcessoMenu = false
            }
        }
        document.addEventListener('click', this._onClickOutside)
    },
    beforeDestroy(){
        document.removeEventListener('click', this._onClickOutside)
    },
}
</script>

<style scoped lang="stylus">
.header-pregao
  padding 5px

.az-form-bar
  border-top-left-radius 5px !important
  border-top-right-radius 5px !important

.item
  display: flex
  label
    font-weight bold
.item-right
  color white
  display flex
  flex-direction column
  label
    font-size 12px
    font-weight bold

.btn-cancelar-envio-proposta
  display flex !important
  flex-direction column
  justify-content center
  margin-right 0 !important

.item
  margin-right 25px !important

.az-form-bar
  .show
    min-height 70px !important
    height auto !important

.actions
 display flex
 align-items center
 gap 12px

.left-actions
display flex
align-items center
gap 8px
margin-right 8px

.select-lote select
 padding 6px 10px
 border-radius 6px
 border 1px solid rgba(0,0,0,0.08)
 background white
 font-size 13px

.btn-acao-imprimir
  padding 6px 10px

.acesso-dropdown
  position relative

.acesso-menu
  position absolute
  top 36px
  right 0
  background white
  border 1px solid rgba(0,0,0,0.1)
  border-radius 6px
  box-shadow 0 2px 8px rgba(0,0,0,0.12)
  z-index 10
  min-width 180px
  padding 6px 0

.acesso-menu-item
  display block
  width 100%
  text-align left
  background transparent
  border none
  padding 8px 12px
  font-size 14px
  cursor pointer
  &:hover
    background rgba(0,0,0,0.05)
</style>
